import { useState, useCallback } from 'react';
import { message } from 'antd';
import { d313Api, QueryParams, ReportRow, UnitSummary, WarehouseUnitSummary } from '../../../services/d313Api';

export function useD313Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ReportRow[]>([]);
  const [unitSummary, setUnitSummary] = useState<UnitSummary[]>([]);
  const [warehouseUnitSummary, setWarehouseUnitSummary] = useState<WarehouseUnitSummary[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await d313Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setUnitSummary(resp.unit_summary || []);
        setWarehouseUnitSummary(resp.warehouse_unit_summary || []);
        setNoData(false);
      } else {
        setData([]);
        setUnitSummary([]);
        setWarehouseUnitSummary([]);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setUnitSummary([]);
    setWarehouseUnitSummary([]);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, unitSummary, warehouseUnitSummary, queried, noData, runQuery, reset };
}
